import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from './commons/Constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'hakone-user';
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('ja');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('ja');
    
  }

  ngOnInit(): void {
    // this.translate.use('ko');
    
  }
}
